// extracted by mini-css-extract-plugin
export var News__wrp = "RecruitNews-module--News__wrp--31HKj";
export var Obi = "RecruitNews-module--Obi--1TFUa";
export var ObiEn = "RecruitNews-module--ObiEn--34LRl";
export var ObiJa = "RecruitNews-module--ObiJa--1DEiH";
export var News = "RecruitNews-module--News--1MrXG";
export var contents = "RecruitNews-module--contents--1D86s";
export var List = "RecruitNews-module--List--3MFk2";